enum SearchQuerySource {
  CommandBar = 'command_bar',
  SearchDrawer = 'search_drawer',
  SearchPage = 'search_page',
  TranslationSettingsDrawer = 'settings_drawer_translation',
  TafsirSettingsDrawer = 'settings_drawer_tafsir',
  ReciterPageChapterList = 'reciter_page_chapter_list',
  Tarteel = 'tarteel',
  SidebarNavigationChaptersList = 'sidebar_navigation_chapter_list',
  SidebarNavigationVersesList = 'sidebar_navigation_verse_list',
  SidebarNavigationJuzsList = 'sidebar_navigation_juz_list',
  SidebarNavigationPagesList = 'sidebar_navigation_page_list',
}

export default SearchQuerySource;
